/**
 * Constants definition.
 *
 * @type {{NEW_CLIENT: string, ADDRESS_CHANGE: string, SIGNATORIES_CHANGE: string,
 * OWNERSHIP_CHANGE: string, BANK_ACCOUNT_CHANGE: string, CONTRACT_TERM_EXTENSION: string,
 * ADD_REMOVE_SUPPLY_POINTS: string}}
 */
const BIG_CLIENT_REQ_REASON = {
  NEW_CLIENT: 'NEW_CLIENT',
  ADDRESS_CHANGE: 'ADDRESS_CHANGE',
  SIGNATORIES_CHANGE: 'SIGNATORIES_CHANGE',
  OWNERSHIP_CHANGE: 'OWNERSHIP_CHANGE',
  BANK_ACCOUNT_CHANGE: 'BANK_ACCOUNT_CHANGE',
  CONTRACT_TERM_EXTENSION: 'CONTRACT_TERM_EXTENSION',
  ADD_REMOVE_SUPPLY_POINTS: 'ADD_REMOVE_SUPPLY_POINTS',
};

/**
 * Enum definition.
 *
 * @type {string[]}
 */
const BIG_CLIENT_REQ_REASON_ENUM = Object.keys(BIG_CLIENT_REQ_REASON);

const NEW_CLIENT = BIG_CLIENT_REQ_REASON_ENUM[0];
const ADDRESS_CHANGE = BIG_CLIENT_REQ_REASON_ENUM[1];
const SIGNATORIES_CHANGE = BIG_CLIENT_REQ_REASON_ENUM[2];
const OWNERSHIP_CHANGE = BIG_CLIENT_REQ_REASON_ENUM[3];
const BANK_ACCOUNT_CHANGE = BIG_CLIENT_REQ_REASON_ENUM[4];
const CONTRACT_TERM_EXTENSION = BIG_CLIENT_REQ_REASON_ENUM[5];
const ADD_REMOVE_SUPPLY_POINTS = BIG_CLIENT_REQ_REASON_ENUM[6];

export {
  BIG_CLIENT_REQ_REASON,
  NEW_CLIENT,
  ADDRESS_CHANGE,
  SIGNATORIES_CHANGE,
  OWNERSHIP_CHANGE,
  BANK_ACCOUNT_CHANGE,
  CONTRACT_TERM_EXTENSION,
  ADD_REMOVE_SUPPLY_POINTS,
  BIG_CLIENT_REQ_REASON_ENUM,
};
